import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BranchesService {
  constructor(private http: HttpClient) {}

  getAllBranches(data) {
    return this.http.post(`${environment.apiUrl}/branches/all`, data).pipe();
  }

  getAllParentBranches(data) {
    return this.http
      .post(`${environment.apiUrl}/branches/all-parent`, data)
      .pipe();
  }

  createBranch(data) {
    return this.http.post(`${environment.apiUrl}/branch/create`, data).pipe();
  }

  updateBranch(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/branch/update/${id}`, data)
      .pipe();
  }

  deleteBranch(id) {
    return this.http.delete(`${environment.apiUrl}/branch/delete/${id}`).pipe();
  }
}
